<template>
  <div>
    <div v-if="!iframeLoaded" :class="theme.confirmationPage">

      <v-card>
        <div v-padding="3">
          <div v-margin.bottom="2">
            <v-text type="title">
              При нажатии «Продолжить» вы продолжите работу во внешней системе для анализа кредитной истории.
            </v-text>
          </div>

          <div v-margin.bottom="2">
            <v-text bold>
              Анализ кредитной истории — за 5 минут превращает кредитную историю клиента в готовый план действий для
              одобрения.
            </v-text>
          </div>

          <div v-margin.bottom="2">
            <v-text>
              Вместо нескольких часов ручного анализа отчетов из разных бюро кредитной истории, поиска ошибок и
              подготовки претензий — система автоматически:
            </v-text>
          </div>

          <div v-margin.bottom="2">
            <ul>
              <li>формирует сводный анализ;</li>
              <li>находит и классифицирует ошибки;</li>
              <li>показывает риски и рекомендации;</li>
              <li>готовит PDF-отчет и претензии в бюро кредитной истории.</li>
            </ul>
          </div>

          <div v-margin.bottom="2">
            <v-text>
              В результате вы экономите время, не пропускаете важные детали, повышаете конверсию в одобрение и можете
              дополнительно монетизировать услугу анализа кредитной истории.
            </v-text>
          </div>

          <div v-padding="3">
            <v-row>
              <v-col xs="5">
                <v-text type="headline">Стоимость</v-text>
              </v-col>
            </v-row>

            <v-row v-margin.top="3" v-margin.bottom="3">
              <v-col xs="3">
                <div>
                  <tariff-card title="Тариф Старт">
                    390 ₽/шт
                  </tariff-card>
                </div>
              </v-col>
              <v-col xs="3">
                <div>
                  <tariff-card title="Тариф Бизнес">
                    295 ₽/шт (выгода 25%)
                  </tariff-card>
                </div>
              </v-col>
              <v-col xs="3">
                <div>
                  <tariff-card title="Тариф Премиум">
                    250 ₽/шт (выгода 35%)
                  </tariff-card>
                </div>
              </v-col>
              <v-col xs="3">
                <div>
                  <tariff-card title="Тариф VIP">
                    200 ₽/шт (выгода 50%)
                  </tariff-card>
                </div>
              </v-col>
            </v-row>
          </div>

          <div :class="theme.confirmationActions">
            <v-button primary large @click="confirmAndLoad" :loading="loading">
              Продолжить
            </v-button>
          </div>
        </div>
      </v-card>

      <v-alert info v-margin.top="3">
        <div v-padding="2">
          <div>
            <v-text type="subheadling">Важно</v-text>
          </div>
          <v-text>Отчеты кредитной истории, сформированные ранее чем за 30 дней до текущей даты, не могут быть
            обработаны.</v-text>
        </div>
      </v-alert>

      <div v-margin.top="3">
        <v-text>
          Обработка загружаемых данных при использовании сервиса осуществляется ООО «ОПТИКАЛ» (ИНН: 4345537530).
          При загрузке материалов в систему вы гарантируете наличие согласий субъектов персональных данных, необходимых
          для законной обработки
          персональных данных указанным лицом. Недостоверность указанной гарантии влечет ответственность в соответствии
          с
          <v-link to="https://exbico.ru/oferta_und" target="_blank">
            Лицензионное соглашение
          </v-link>
          и законодательством.
        </v-text>
      </div>

    </div>

    <refinance-analysis v-else :loading="loading" :error="error" :iframe-url="iframeUrl" :on-reload="handleReload"
      :theme="theme" />
  </div>
</template>

<script>
import { getLink } from '../../../services/api/refinance';
import RefinanceAnalysis from './RefinanceAnalysis.vue';
import theme from './theme.scss';
import { TariffCard } from "../tariffCard";

export default {
  name: 'RefinanceAnalysisContainer',
  props: {
    theme: {
      type: Object,
      default() {
        return theme;
      }
    }
  },
  components: {
    TariffCard,
    RefinanceAnalysis
  },
  data() {
    return {
      loading: false,
      iframeLoaded: false,
      iframeUrl: null,
      error: null
    };
  },
  mounted() {
    this.iframeLoaded = false;
  },
  methods: {
    async confirmAndLoad() {
      this.loading = true;
      this.error = null;

      try {
        const response = await getLink();
        this.iframeUrl = response.data.url;
        this.iframeLoaded = true;
      } catch (err) {
        console.error('Ошибка при загрузке iframe:', err);

        if (err.data && err.data.message) {
          this.error = err.data.message;
        } else {
          this.error = 'Не удалось загрузить данные анализа. Попробуйте позже.';
        }

        this.iframeLoaded = false;
      } finally {
        this.loading = false;
      }
    },

    handleReload() {
      this.iframeLoaded = false;
      this.error = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// RefinanceAnalysisContainer.vue?bae58606